import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class GoalsListItemTitleComponent extends Component {
  @service betaToggle;
}
